export const price = (price: number | string | null): undefined | string => {
    if (!price) {
        return
    }

    return new Intl.NumberFormat('ru', {style: 'currency', currency: 'RUB', maximumFractionDigits: 0}).format(
        +price,
    )
}